import { Button } from '@/components/elements/forms/buttons';
import { ListItem, ListItemContent } from '@/components/elements/lists';
import Icon from '@/components/icons/Icon';
import Modal from '@/components/modules/modals/redesign/Modal/Modal';
import { classnames } from '@/helpers';
import useMobileView from '@/hooks/useMobileView';
import { _s } from '@/locale';

const baseTranslationKey = 'features.ProfilePages.modules.NewCustomerModal';

const NewCustomerModal = ({ onClose, onVerify }: { onClose: () => void; onVerify: () => void }) => {
  const { isMobileView } = useMobileView();
  return (
    <Modal className={`${isMobileView ? 'h-screen' : 'md:max-w-[496px]'}`} isOpen={true}>
      <div className={`${isMobileView ? 'flex h-full flex-col' : 'h-[590px]'}`}>
        <Modal.Header
          newDesign={true}
          title={_s(`${baseTranslationKey}.title`)}
          floating={!isMobileView}
          onClose={onClose}
        />
        <div
          className={classnames(
            'p-2xl gap-xl bg-surface_l4 relative flex flex-col overflow-hidden',
            isMobileView ? 'flex-1' : 'h-full rounded-b-lg',
          )}>
          <div className="gap-xl z-10 flex h-full flex-col justify-end">
            <h2 className={`${isMobileView ? 'text-h-l' : 'text-h-xl'} font-bold`}>
              {_s(`${baseTranslationKey}.subTitle`)}
            </h2>
            <h4 className={`text-l`}>{_s(`${baseTranslationKey}.body`)}</h4>
            <ul className={`gap-sm flex flex-col`}>
              <ListItem
                leftPadding={false}
                className="pb-0 pt-0"
                leftSlot={<Icon color="fg_positive" variant="check" />}>
                <ListItemContent
                  {...(isMobileView
                    ? { content: _s(`${baseTranslationKey}.list.1`) }
                    : { subTitle: _s(`${baseTranslationKey}.list.1`) })}
                />
              </ListItem>
              <ListItem
                className="pb-0 pt-0"
                leftPadding={false}
                leftSlot={<Icon color="fg_positive" variant="check" />}>
                <ListItemContent
                  {...(isMobileView
                    ? { content: _s(`${baseTranslationKey}.list.2`) }
                    : { subTitle: _s(`${baseTranslationKey}.list.2`) })}
                />
              </ListItem>
              <ListItem
                className="pb-0 pt-0"
                leftPadding={false}
                leftSlot={<Icon color="fg_positive" variant="check" />}>
                <ListItemContent
                  {...(isMobileView
                    ? { content: _s(`${baseTranslationKey}.list.3`) }
                    : { subTitle: _s(`${baseTranslationKey}.list.3`) })}
                />
              </ListItem>
            </ul>
            <Button
              label={_s(`${baseTranslationKey}.cta`)}
              type="submit"
              size="lg"
              onClick={onVerify}
              rightIcon={<Icon variant={'payment-method-bank-id'} />}
            />
          </div>
          <div className={classnames('absolute left-0 top-0 z-0 w-full', isMobileView && 'overflow-hidden')}>
            <picture>
              <source srcSet={'/images/verify-company-background.png'} media="(min-width: 768px)" />
              <img src={'/images/verify-company-background.png'} alt="" />
            </picture>
          </div>
          <div className="absolute bottom-0 left-0 h-full w-full bg-gradient-to-t from-white to-transparent"></div>
        </div>
      </div>
    </Modal>
  );
};

export default NewCustomerModal;
